import * as React from "react";
import {cx} from "emotion";

import "./download-delivery.scss";

import {getPriceByQuantity} from "@Common/logic/template-options/get-price-by-quantity";
import {cs}                 from "@Common/react/chain-services";
import {formatMoney}        from "@Common/ui-components/language/format-money";
import {chain}              from "@Common/utils/fs";

import {FlexSelect} from "../../../../../common/components/flex-select/flex-select";

export const DownloadDelivery = ({showErrors, fileTypes, state, paperPrice, urls}) => cs(
    ({}) => (
        <div className={cx("download-delivery-8vc", {showErrors})}>
            <div className="header">
                <div className="title">
                    File Type
                </div>

            </div>

            <div className="card">

                {FlexSelect({
                    list: fileTypes,
                    isSelected: (v) => state.value === v,
                    valueToLabel: v=>v,
                    onChange: state.onChange,
                })}

                {cs(
                    ({}, next) => (
                        paperPrice == null ? (
                            <div className="error">
                                Invalid Pricing.{" "}
                                {/*Please call for assistance{" "}*/}
                                {/*<CompanySupportPhone/>*/}
                            </div>
                        ) : (
                            next()
                        )
                    ),
                    ["price", (_, next) => next(getPriceByQuantity(paperPrice, 1)?.price)],
                    ({price}) => !price ? (
                        chain(
                            urls?.[state.value],
                            (links) => !links?.length ? (
                                <div className="no-data">
                                    <div className="main">
                                        No download link(s) available
                                    </div>
                                    <div className="sub">
                                        Please go back to Customize step and wait for the Template editor to finish initialization, and the download links will be available
                                    </div>
                                </div>
                            ) : (
                                <div className="download-links">
                                    {links?.map( (link, i) => (
                                        <a
                                            key={i}
                                            href={link}
                                            target="_blank"
                                            download
                                            className={cx("download-btn")}
                                        >
                                            Download {state.value.toUpperCase()}{" "}
                                            Side {i+1}
                                        </a>
                                    ))}
                                </div>
                            ),
                        )
                    ) : (
                        <div className="form-group">
                            <div className="control-label">
                                {state.value.toUpperCase()} Download
                            </div>

                            <div className="amount">
                                {formatMoney(price)}
                            </div>
                        </div>
                    ),
                )}
            </div>
        </div>
    ),
);
